import React from "react";
import { RenderProps } from "../DynamicColumn";

export default (props: RenderProps) => {
  return <>{props.item[props.attribute]}</>;
};
